<template>
  <ButtonTooltip
    icon
    x-small
    color="primary"
    target="_blank"
    class="zoho-icon"
    :disabled="!zohoId"
    :href="href"
    tooltip-text="Click to open in Zoho"
  >
    <ESvgIcon icon="zoho-crm" :color="color || defaultColor" />
  </ButtonTooltip>
</template>

<script>
import ButtonTooltip from "@evercam/shared/components/ButtonTooltip.vue"
export default {
  name: "OpenInZohoButton",
  components: { ButtonTooltip },
  props: {
    zohoId: {
      type: [String, Number, null],
      default: null,
    },
    type: {
      type: [String, null],
      default: null,
    },
    color: {
      type: [String, null],
      default: null,
    },
  },
  computed: {
    defaultColor() {
      return this.zohoId ? this.$vuetify.theme.themes.light.primary : "grey"
    },
    href() {
      let route = ""
      switch (this.type) {
        case "camera":
          route = `tab/CustomModule4/${this.zohoId}`
          break
        case "user":
          route = `tab/Contacts/${this.zohoId}`
          break
        case "project":
          route = `tab/CustomModule12/${this.zohoId}`
          break
        case "company":
          route = `tab/Accounts/${this.zohoId}`
          break
        default:
          break
      }

      return `${this.$config.public.zohoCrmUrl}/${route}`
    },
  },
}
</script>
